<template>
  <v-dialog max-width="400px" v-model="dialog" :disabled="LOGIN_STATE || !firebaseEnabled">
    <template v-slot:activator="{ on, attrs }">
      <v-btn text :class="{ 'hidden-xs-only': hiddenOnMobile }" v-bind="attrs" v-on="on" @click="checkedSignOut" :loading="loading.signOutButton" :disabled="!firebaseEnabled && !LOGIN_STATE">
        {{ buttonName }}
        <v-icon right>mdi-login-variant</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h1 class="title">{{ t('login.adminTitle') }}</h1>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field v-model="login.value" :error-messages="login.error" @input="login.error = ''" :rules="[v => (v || '').length >= 3 || t('login.minLength')]" type="email" :label="t('login.email')" prepend-icon="mdi-account-circle" />
          <v-text-field
            v-model="password.value"
            :error-messages="password.error"
            @input="password.error = ''"
            :rules="[v => (v || '').length >= 3 || t('login.minLength')]"
            :type="showPassword ? 'text' : 'password'"
            :label="t('login.password')"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text block color="success" @click="submit" :loading="loading.submitButton" :disabled="!firebaseEnabled">{{ t('login.login') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { auth, firebaseEnabled } from '@/fb'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['hiddenOnMobile'],
  data: () => ({
    firebaseEnabled,
    dialog: false,
    // signedIn: false,
    loading: {
        submitButton: false,
        signOutButton: false,
    },
    login: {
        value: "",
        error: "",
    },
    password: {
        value: "",
        error: "",
    },
    showPassword: false,
  }),
  computed: {
    ...mapGetters(['LOGIN_STATE']),
    buttonName() {
      return this.LOGIN_STATE ? this.t('login.logout') : this.t('login.login')
    }
  },
  methods: {
    ...mapActions(['TOGGLE_LOGIN']),
    submit() {
        if (!this.firebaseEnabled) {
            this.loading.submitButton = false
            return
        }

        this.loading.submitButton = true
        this.toggleSignIn(this.login.value, this.password.value)
    },
    toggleSignIn(email, password) {
        if (!auth) {
            this.loading.submitButton = false
            this.loading.signOutButton = false
            return
        }

        if (auth.currentUser && !auth.currentUser.isAnonymous) {
            auth.signOut().then(() => {
                this.loading.signOutButton = false
            }).catch((error) => {
                this.loading.signOutButton = false
                console.log(error)
            })
        } else {
            if (this.$refs.form.validate()) {
                auth.signInWithEmailAndPassword(email, password)
                .then(() => {
                    this.dialog = false
                    this.loading.submitButton = false
                })
                .catch((error) => {
                    this.loading.submitButton = false

                    var errorCode = error.code;
                    var errorMessage = error.message;

                    if (errorCode === 'auth/wrong-password') {
                        // alert('Неправильный пароль.');
                        this.password.error = this.t('login.wrongPassword')
                    } else {
                        // alert(errorMessage);
                        this.login.error = errorMessage
                    }
                    console.log(error);
                })
            }
        }
    },
    checkedSignOut() {
        if (this.LOGIN_STATE) {
            this.loading.signOutButton = true
            this.toggleSignIn()
        }
    }
  },
  mounted() {
      if (!auth) {
          this.TOGGLE_LOGIN(false)
          return
      }

      auth.onAuthStateChanged(user => {
          this.TOGGLE_LOGIN(!!user && !user.isAnonymous)
          if (this.LOGIN_STATE) {
              // this.$root.$emit('sign-in')
              this.TOGGLE_LOGIN(true)
          } else {
            // this.$root.$emit('sign-out')
              this.TOGGLE_LOGIN(false)
          }
      })
      
      // this.$root.$on('request-sign-status', () => {
      //     this.$root.$emit(this.signedIn ? 'sign-in' : 'sign-out')
      // })
  },
//   created() {
//     //   window.addEventListener('unload', alert('unload'))
//       auth.signInAnonymously().catch(function(error) {
//         // Handle Errors here.
//         var errorCode = error.code
//         var errorMessage = error.message
        
//         console.log(errorCode, errorMessage)
//       })
//   }
};
</script>